import type { DatabaseEngineId } from '@/core/engines';
import type { SqlSnippetEngineId } from '../types/sqlSnippetTypes';

// SQL snippets are not offered for kusto (KQL isn't SQL — monaco-kusto owns its
// own IntelliSense, S4) — unrecognized/unsupported engines collapse to 'mssql'.
export const normalizeSnippetEngineId = (engineId: DatabaseEngineId): SqlSnippetEngineId => {
  if (engineId === 'pgsql') return 'pgsql';
  if (engineId === 'sqlite') return 'sqlite';
  if (engineId === 'mysql') return 'mysql';
  if (engineId === 'oracle') return 'oracle';
  return 'mssql';
};

export const byEngine = <T>(
  engineId: DatabaseEngineId,
  options: { readonly mssql: T; readonly pgsql: T; readonly sqlite?: T; readonly mysql?: T; readonly oracle?: T }
): T => {
  const normalized = normalizeSnippetEngineId(engineId);

  if (normalized === 'pgsql') return options.pgsql;
  if (normalized === 'sqlite') return options.sqlite ?? options.pgsql;
  if (normalized === 'mysql') return options.mysql ?? options.pgsql;
  if (normalized === 'oracle') return options.oracle ?? options.pgsql;
  return options.mssql;
};
